import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, Popover, OverlayTrigger, Tooltip} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, checkboxField} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import {COMPANY_CONFIGS_UPDATED, sendCompanyConfigs, queryCompanyConfigs} from '../actions'
import {CompanyConfigs} from '../models'
import i18n from '../i18n'
import style from './CompanyConfigsPopover.less'

class CompanyConfigsPopover extends Component {
    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch} = this.props
        dispatch(queryCompanyConfigs())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.company != this.props.company) {
            const {dispatch} = nextProps
            dispatch(queryCompanyConfigs())
        }
    }

    _sendCmd() {
        const {dispatch, onHide} = this.props

        return dispatch(sendCompanyConfigs()).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, cmd, company, onHide, ...others} = this.props

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const prefixField = (field) => {
            var value = field.value

            function onChange(event) {
                const value = event.target.value
                const nextValue = value.toUpperCase().replace(/[^A-Z]/g, '').substring(0, 3)
                field.onChange(nextValue)
            }

            value = value || '' // fix uncontrolled input issue

            return {...field, value, onChange}
        }

        const tooltip = (text) => (
            <Tooltip
                className='tooltip-primary'>
                {text}
            </Tooltip>
        )

        const tooltipInputAddon = (text) => (
            <OverlayTrigger
                placement='bottom'
                overlay={tooltip(text)}>
                <span className={style.info}>?</span>
            </OverlayTrigger>
        )

        return (
            <Popover
                title={i18n.configs}
                {...others}>
                <div className={style.defaultContent}>
                    <form className='form-horizontal'>
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='text'
                            name='prefix'
                            label={requiredLabel(i18n.ticketUidGeneratorPrefix)}
                            addonAfter={tooltipInputAddon(i18n.ticketUidGeneratorPrefixText)}
                            {...prefixField(form.ticketUidGenerator.uidPrefix())} />
                        <Input
                            wrapperClassName='col-sm-offset-3 col-sm-9'
                            type='checkbox'
                            name='acknowledge'
                            label={requiredLabel(i18n.acknowledgeTicketUidGenerator)}
                            {...checkboxField(form.ticketUidGenerator.acknowledge())} />
                    </form>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </div>
            </Popover>
        )
    }
}

CompanyConfigsPopover = connectForm({
    target: 'companyConfigs',
    schema: CompanyConfigs.schema,
    action: COMPANY_CONFIGS_UPDATED
})(CompanyConfigsPopover)

CompanyConfigsPopover = connect((state) => ({
    companyConfigs: state.company.companyConfigs
}))(CompanyConfigsPopover)

export default CompanyConfigsPopover


// WEBPACK FOOTER //
// ./lib/company/components/CompanyConfigsPopover.js